export const isValidName = (val: string): boolean => {
  // Allow groups of alpha with optional apostrophe separated by one whitespace or hyphen
  // Accounts for unicode variants of apostrophe
  return /^([a-zA-Z'‘’]+([-\s]['‘’a-zA-Z]+)?)*$/gi.test(val);
}
